import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    users:[],
    conversation:{
        user:null,
        messages:[]
    }
}
export const chatSlice = createSlice({
    name: 'chats',
    initialState: initialState,
    reducers: {
        setUsersChat: (state, { payload }) => {     
            state.users = payload   
        },
        appendMessage: (state, { payload }) => {     
            state.conversation.messages.push(payload)
        },
        setConversationEntity: (state, { payload }) => {     
            state.conversation.user = payload.user              
        },
        setConversationMessage: (state, { payload }) => {            
            state.conversation.messages = payload.messages.reverse()
        },
        clearChat: ()=> initialState,
        clearConversationMessage: (state)=> {
            state.conversation.messages = initialState.conversation.messages 
        },
        clearConversation: (state)=> {
            state.conversation.messages = initialState.conversation.messages 
            state.conversation.user = initialState.conversation.user 
        },

    },
});


export const { setUsersChat,setConversationEntity, setConversationMessage,appendMessage,clearChat, clearConversationMessage, clearConversation
} = chatSlice.actions;